import { createAxiosInstance } from '../utils/axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8083/api';

// Create axios instance with default config and interceptors
const settingsAPI = createAxiosInstance({
  baseURL: `${API_BASE_URL}/settings`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Settings service functions
export const settingsService = {
  // Get public settings (no auth required)
  getPublicSettings: async () => {
    try {
      const response = await settingsAPI.get('/public');
      return response.data;
    } catch (error) {
      console.error('Error fetching public settings:', error);
      // Return default settings on error
      return { bannerEnabled: true };
    }
  },

  // Get all settings (admin only)
  getAllSettings: async () => {
    try {
      const response = await settingsAPI.get('');
      return response.data;
    } catch (error) {
      console.error('Error fetching all settings:', error);
      throw error;
    }
  },

  // Update banner settings (admin only)
  updateBannerSettings: async (bannerEnabled) => {
    try {
      const response = await settingsAPI.put('/banner.enabled', { value: bannerEnabled.toString() });
      return response.data;
    } catch (error) {
      console.error('Error updating banner settings:', error);
      throw error;
    }
  },

  // Update specific setting (admin only)
  updateSetting: async (key, value) => {
    try {
      const response = await settingsAPI.put(`/${key}`, { value });
      return response.data;
    } catch (error) {
      console.error('Error updating setting:', error);
      throw error;
    }
  },

  // Reset settings to default (admin only)
  resetToDefault: async () => {
    try {
      const response = await settingsAPI.post('/reset');
      return response.data;
    } catch (error) {
      console.error('Error resetting settings:', error);
      throw error;
    }
  },
};

export default settingsService;